import React, { useState, useRef } from 'react';

function Disclaimer({ portal, onAccept }) {
  const [scrolled, setScrolled] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const contentRef = useRef(null);

  const handleScroll = (e) => {
    const el = e.target;
    const atBottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 50;
    if (atBottom) setScrolled(true);
  };

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center p-5">
      <div className="bg-gray-900 border border-gray-800 rounded-2xl w-full max-w-md flex flex-col" style={{maxHeight: '90vh'}}>

        {/* Header */}
        <div className="p-6 border-b border-gray-800">
          <div className="flex items-center gap-2 mb-3">
            <svg width="24" height="24" viewBox="0 0 100 130" fill="none">
              <defs>
                <linearGradient id="dg" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor="#f2c832"/>
                  <stop offset="100%" stopColor="#e8496a"/>
                </linearGradient>
              </defs>
              <path d="M58 4L84 4L84 10L68 10L68 54L84 54L84 62L52 126L42 126L62 72L44 72L44 62L16 62L16 54L32 54L32 10L16 10L16 4L42 4L42 54L58 54Z" fill="url(#dg)"/>
            </svg>
            <span className="font-bold text-sm bg-gradient-to-r from-yellow-400 to-pink-500 bg-clip-text text-transparent">ArcBolt</span>
            <span className={`ml-auto text-xs px-2 py-1 rounded ${portal === 'prep' ? 'bg-yellow-950 text-yellow-400 border border-yellow-800' : 'bg-green-950 text-green-400 border border-green-800'}`}>
              {portal === 'prep' ? '⚡ PREP Signals' : '🪞 MirrorTrade'}
            </span>
          </div>
          <h2 className="text-lg font-bold text-white">Terms & Disclaimer</h2>
          <p className="text-xs text-gray-500 mt-1">Please read carefully before continuing</p>
        </div>

        {/* Scrollable content */}
        <div
          ref={contentRef}
          onScroll={handleScroll}
          className="flex-1 overflow-y-auto p-6 space-y-5"
          style={{maxHeight: '50vh'}}
        >
          <div>
            <h3 className="text-xs font-semibold text-yellow-400 uppercase tracking-wide mb-2">Not Financial Advice</h3>
            <p className="text-xs text-gray-400 leading-relaxed">
              ArcBolt is a <span className="text-white font-medium">technology platform only</span>. All signals, data, and tools provided are for informational purposes only. We are not licensed financial advisors, brokers, or fund managers. Nothing on this platform constitutes financial advice.
            </p>
          </div>

          <div>
            <h3 className="text-xs font-semibold text-yellow-400 uppercase tracking-wide mb-2">Trading Risk</h3>
            <p className="text-xs text-gray-400 leading-relaxed">
              Cryptocurrency trading involves <span className="text-white font-medium">substantial risk of loss</span>, including the possibility of losing your entire investment. Past performance does not guarantee future results. Only trade with money you can afford to lose completely.
            </p>
          </div>

          {portal === 'prep' && (
            <div>
              <h3 className="text-xs font-semibold text-yellow-400 uppercase tracking-wide mb-2">PREP Signals</h3>
              <p className="text-xs text-gray-400 leading-relaxed">
                Signals are generated by an <span className="text-white font-medium">automated algorithm only</span> — no human analysis. Confidence percentages represent algorithmic scoring, not guaranteed profit probability. Even high-confidence signals can and do fail. Risky signals have significantly higher failure rates.
              </p>
            </div>
          )}

          {portal === 'mt' && (
            <div>
              <h3 className="text-xs font-semibold text-yellow-400 uppercase tracking-wide mb-2">MirrorTrade</h3>
              <p className="text-xs text-gray-400 leading-relaxed">
                MirrorTrade is an <span className="text-white font-medium">automated software tool only</span>. By enabling auto-copy, you authorize the software to execute trades per your own settings. ArcBolt does not make trading decisions, does not hold or access your private keys. Copied wallet past performance does not guarantee future results.
              </p>
            </div>
          )}

          <div>
            <h3 className="text-xs font-semibold text-yellow-400 uppercase tracking-wide mb-2">Zero Liability</h3>
            <p className="text-xs text-gray-400 leading-relaxed">
              ArcBolt and its operators shall <span className="text-white font-medium">not be held responsible</span> for any losses, damages, or claims under any circumstances. You are solely responsible for all trading decisions and their outcomes.
            </p>
          </div>

          <div>
            <h3 className="text-xs font-semibold text-yellow-400 uppercase tracking-wide mb-2">Your Responsibility</h3>
            <p className="text-xs text-gray-400 leading-relaxed">
              By using ArcBolt, you confirm that you are of legal age in your jurisdiction, you understand the risks involved, and you take full responsibility for all decisions made using this platform.
            </p>
          </div>

          {!scrolled && (
            <p className="text-xs text-gray-600 text-center animate-pulse">↓ Scroll down to continue</p>
          )}
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-gray-800">
          {scrolled && (
            <label className="flex items-start gap-3 mb-4 cursor-pointer">
              <input
                type="checkbox"
                checked={agreed}
                onChange={e => setAgreed(e.target.checked)}
                className="mt-0.5 accent-yellow-400"
              />
              <span className="text-xs text-gray-400 leading-relaxed">
                I have read and understood the terms above. I accept full responsibility for my trading decisions and waive all rights to hold ArcBolt liable for any outcomes.
              </span>
            </label>
          )}

          <button
            onClick={onAccept}
            disabled={!scrolled || !agreed}
            className="w-full bg-gradient-to-r from-yellow-500 to-pink-600 text-white font-semibold py-2.5 rounded-lg text-sm hover:opacity-90 transition-all disabled:opacity-30 disabled:cursor-not-allowed"
          >
            I Agree — Continue
          </button>

          {!scrolled && (
            <p className="text-xs text-gray-700 text-center mt-2">Read all terms to continue</p>
          )}
        </div>

      </div>
    </div>
  );
}

export default Disclaimer;